import { createContext, useContext, useEffect, useState, type ReactNode } from 'react'
import { supabase } from '@/lib/supabase'

interface EscritorioCtx {
  nome: string
  /** URL pública da logo escura — usar em fundos dark (sidebar, portal) */
  logoUrl: string | null
  /** URL pública da logo clara — usar em PDFs e fundos brancos */
  logoClaraUrl: string | null
}

const DEFAULT: EscritorioCtx = { nome: 'IFP Arquitetura', logoUrl: null, logoClaraUrl: null }

const CTX = createContext<EscritorioCtx>(DEFAULT)

function publicUrl(path: string | null): string | null {
  if (!path) return null
  return supabase.storage.from('branding').getPublicUrl(path).data.publicUrl
}

export function EscritorioProvider({ children }: { children: ReactNode }) {
  const [ctx, setCtx] = useState<EscritorioCtx>(DEFAULT)

  useEffect(() => {
    supabase
      .from('escritorios')
      .select('nome, logo_path, logo_clara_path')
      .eq('id', 1)
      .single()
      .then(({ data }) => {
        if (!data) return
        setCtx({
          nome: data.nome ?? 'IFP Arquitetura',
          logoUrl: publicUrl(data.logo_path),
          logoClaraUrl: publicUrl(data.logo_clara_path),
        })
      })
  }, [])

  return <CTX.Provider value={ctx}>{children}</CTX.Provider>
}

export function useEscritorio(): EscritorioCtx {
  return useContext(CTX)
}
